
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tanya",
      function () {
        return require("private-next-pages/tanya.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tanya"])
      });
    }
  